module.exports = __webpack_public_path__ + "static/sandmann-090ba61add104efcd71a5bfd8d44aa1f.jpg";